import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/Button';
import { routePaths } from '@/routes/paths';

export function NotFoundPage() {
  return (
    <div className="relative grid min-h-dvh place-items-center overflow-hidden bg-slate-100 p-4 dark:bg-slate-950">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-brand-100/60 via-sky-50/50 to-transparent dark:from-brand-950/40 dark:via-slate-950 dark:to-transparent" />
      <div className="pointer-events-none absolute left-1/2 top-[-8rem] h-72 w-72 -translate-x-1/2 rounded-full bg-brand-200/30 blur-3xl dark:bg-brand-500/10" />
      <div className="relative w-full max-w-md rounded-[28px] border border-slate-200/80 bg-white/95 px-6 py-8 text-center shadow-[0_20px_70px_-45px_rgba(15,23,42,0.45)] backdrop-blur dark:border-slate-800 dark:bg-slate-900/96">
        <div className="space-y-4">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-brand-700 dark:text-brand-300">404</p>
          <h1 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-white">Page not found</h1>
          <p className="text-sm leading-6 text-slate-500 dark:text-slate-400">The page you requested does not exist.</p>
        </div>
        <div className="mt-6">
          <Link to={routePaths.app.dashboard}>
            <Button className="rounded-2xl px-6">Back to dashboard</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
